import { LayoutType, WidgetDimensions } from '../../utils/layouts';

export const getAltText = (contentName: string) => {
  return `Cover image for ${contentName}`;
};

export const getImageHeightWidth = ({ height }: LayoutType, isDesktop: boolean) => {
  if (!isDesktop) {
    return [56, 56];
  }
  switch (height) {
    case WidgetDimensions.S:
      return [74, 74];
    case WidgetDimensions.M:
      return [72, 72];
    case WidgetDimensions.L:
      return [60, 60];
    default:
      return [60, 60];
  }
};

export const DIMENSIONS_TO_LAYOUT_CONFIG_MAP = {
  // Small Height
  ['s-xxs']: {
    gridTemplateColumns: 1,
    cardsCount: 2,
    rowSpanClasses: ['', '', ''],
    colSpanClasses: ['', '', ''],
  },
  ['s-xs']: {
    gridTemplateColumns: 1,
    cardsCount: 2,
    rowSpanClasses: ['', '', ''],
    colSpanClasses: ['', '', ''],
  },
  ['s-s']: {
    gridTemplateColumns: 1,
    cardsCount: 2,
    rowSpanClasses: ['', '', ''],
    colSpanClasses: ['', '', ''],
  },
  ['s-m']: {
    gridTemplateColumns: 1,
    cardsCount: 2,
    rowSpanClasses: ['', '', ''],
    colSpanClasses: ['', '', ''],
  },
  ['s-l']: {
    gridTemplateColumns: 1,
    cardsCount: 2,
    rowSpanClasses: ['', '', ''],
    colSpanClasses: ['', '', ''],
  },

  // Medium Height
  ['m-xxs']: {
    gridTemplateColumns: 1,
    cardsCount: 3,
    rowSpanClasses: ['', '', '', ''],
    colSpanClasses: ['', '', '', ''],
  },
  ['m-xs']: {
    gridTemplateColumns: 1,
    cardsCount: 3,
    rowSpanClasses: ['', '', '', ''],
    colSpanClasses: ['', '', '', ''],
  },
  ['m-s']: {
    gridTemplateColumns: 1,
    cardsCount: 3,
    rowSpanClasses: ['', '', '', ''],
    colSpanClasses: ['', '', '', ''],
  },
  ['m-m']: {
    gridTemplateColumns: 1,
    cardsCount: 3,
    rowSpanClasses: ['', '', '', ''],
    colSpanClasses: ['', '', '', ''],
  },
  ['m-l']: {
    gridTemplateColumns: 2,
    cardsCount: 3,
    rowSpanClasses: ['', '', '', ''],
    colSpanClasses: ['', '', '', ''],
  },

  // Large Height
  ['l-xxs']: {
    gridTemplateColumns: 1,
    cardsCount: 5,
    rowSpanClasses: [''],
    colSpanClasses: [''],
  },
  ['l-xs']: {
    gridTemplateColumns: 1,
    cardsCount: 5,
    rowSpanClasses: [''],
    colSpanClasses: [''],
  },
  ['l-s']: {
    gridTemplateColumns: 1,
    cardsCount: 5,
    rowSpanClasses: [''],
    colSpanClasses: [''],
  },
  ['l-m']: {
    gridTemplateColumns: 1,
    cardsCount: 5,
    rowSpanClasses: [''],
    colSpanClasses: [''],
  },
  ['l-l']: {
    gridTemplateColumns: 2,
    cardsCount: 5,
    rowSpanClasses: [''],
    colSpanClasses: [''],
  },
} as Record<
  string,
  {
    gridTemplateColumns: number;
    cardsCount: number;
    rowSpanClasses: string[];
    colSpanClasses: string[];
  }
>;

export const DEFAULT_MOBILE_LAYOUT = {
  gridTemplateColumns: 1,
  cardsCount: 3,
  rowSpanClasses: ['', '', ''],
  colSpanClasses: ['', '', ''],
};
